import React from "react";
import { VStack } from "@chakra-ui/react";
import SymptomsSelector from "components/SymptomsSelector";

const SignsAndSymptoms = () => {
  return (
    <VStack spacing={6} align="stretch">
      <SymptomsSelector />
    </VStack>
  );
};

export default SignsAndSymptoms;
